import { TODAY, YESTERDAY, THIS_WEEK, LAST_WEEK, THIS_MONTH, LAST_MONTH, LAST_THIRTY_DAYS, LAST_THREE_MONTHS, THIS_QUARTER, LAST_QUARTER, LAST_YEAR, THIS_YEAR } from 'foundations-components/transitional/components/Dates';
export const CUSTOM_PRESET_ID = 'CUSTOM';
export const ALL_PRESET_ID = 'ALL';
export const ALL_DATE_PRESET = {
  presetId: ALL_PRESET_ID,
  startDate: null,
  endDate: null
};
export const DATE_RANGE_PRESETS = {
  [TODAY.presetId]: TODAY,
  [YESTERDAY.presetId]: YESTERDAY,
  [THIS_WEEK.presetId]: THIS_WEEK,
  [LAST_WEEK.presetId]: LAST_WEEK,
  [THIS_MONTH.presetId]: THIS_MONTH,
  [LAST_MONTH.presetId]: LAST_MONTH,
  [LAST_THIRTY_DAYS.presetId]: LAST_THIRTY_DAYS,
  [LAST_THREE_MONTHS.presetId]: LAST_THREE_MONTHS,
  [THIS_QUARTER.presetId]: THIS_QUARTER,
  [LAST_QUARTER.presetId]: LAST_QUARTER,
  [LAST_YEAR.presetId]: LAST_YEAR,
  [THIS_YEAR.presetId]: THIS_YEAR
};